// extracted by mini-css-extract-plugin
export default {"Header":"App_Header__FG5rT","Info":"App_Info__GTvaf","Keyboard":"App_Keyboard__JM5um","lastKeyboardRow":"App_lastKeyboardRow__XplFu"};